import axios from '@/allotment/axios'

export default {
  count: data => axios.post('/device/count/types', data), //获取设备数量统计
  remark: data => axios.post('/device/update/remark', data), //保存设备
  advise: data => axios.post('/device/update/useSuggestion', data), //保存设备操作建议
  page: data => axios.post('/device/select/page', data), //获取设备列表
  export: data => axios.post('/device/export', data, { notbody: true, responseType: 'blob', timeout: 10 * 60000 }), //设备列表导出
  status: data => axios.post('/device/update/status', data), //修改设备状态
  nav: data => axios.post('/device/detail/tree', data), //获取详情左侧导航
  get: id => axios.get(`/device/get/${id}`), //获取设备详情信息
  batteryChart: data => axios.post('/device/detail/line/chart', data), //获取设备详情图表信息New
  postConfig: data => axios.post('/device/detail/update/config', data), //修改配置属性
  postAllConfig: data => axios.post('/device/detail/batch/config', data), //批量修改配置属性
  getConfig: id => axios.get(`/device/detail/config/${id}`), //获取设备配置属性
  postExport: data => axios.post('/device/detail/export', data, { notbody: true, responseType: 'blob', timeout: 10 * 60000 }), //导出图表
  getUnstation: data => axios.post('/device/select/unstation', data), //查询自己未入站的设备
  add: data => axios.post('/device/bind', data), //添加设备
  select: data => axios.post('/device/select/list', data), //条件查询集合
  getModel: id => axios.get(`/device/detail/model/info/${id}`), //获取设备模块属性
  getGrtDetail: id => axios.get(`/chs/grt/info/${id}`), //获取格润特详情信息
  getGrtOverview: id => axios.get(`/chs/grt/overview/${id}`), //获取格润特预览信息
  getGrtConfig: id => axios.get(`/chs/grt/config/${id}`), //获取格润特配置信息
  postGrtConfig: data => axios.post('/chs/grt/update/config', data), //修改格润特配置信息

  intelessRestart: id => axios.get(`/srDgl/restart/${id}`), //朔日-采集器重启
  intelessOverview: id => axios.get(`/srDgl/overview/${id}`), //朔日-查询采集器概览信息
  intelessInvOverview: id => axios.post('/srInv/overview', { id }), //朔日-逆变器概览信息
  intelessInvInfo: id => axios.get(`/srInv/log/${id}`), //朔日-逆变器详细信息

  intelessInvSosenOverview: id => axios.post('/inv/sosen/overview', { id }), //松盛-逆变器概览信息
  intelessInvSosenInfo: id => axios.post('/inv/sosen/detail', { id }), //松盛-逆变器详细信息

  getV2gOverview: id => axios.get(`/v2g/overview/${id}`), //获取V2G概览信息
  getV2gDetail: id => axios.get(`/v2g/detail/${id}`), //获取V2G详细信息
  getV2gConfig: id => axios.get(`/v2g/config/${id}`), //获取V2g配置信息
  postV2gConfig: data => axios.post('/v2g/update/config', data) //修改V2g配置信息
}
